import Button from "@mui/material/Button";
import { IoIosMenu } from "react-icons/io";
import { FaAngleDown } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { FaAngleRight } from "react-icons/fa6";
import { MyContext } from "../../../App";
import CountryDropdown from "../../CountryDropdown";
import Logo from "../../../assets/images/sabba krish logo.png";
import { RiLogoutCircleRFill } from "react-icons/ri";
import { IoMdClose } from "react-icons/io";

import "./nav.css";
const Navigation = (props) => {
  const [isopenSidebarVal, setisopenSidebarVal] = useState(false);
  const [isOpenNav, setIsOpenNav] = useState(false);
  const [isOpenSubMenuIndex, setIsOpenSubMenuIndex] = useState(null);
  const [isOpenSubMenu_, setIsOpenSubMenu_] = useState(false);

  const context = useContext(MyContext);
  const history = useNavigate();

  useEffect(() => {
    setIsOpenNav(props.isOpenNav);
  }, [props.isOpenNav]);

  const IsOpenSubMenu = (index) => {
    setIsOpenSubMenuIndex(index);
    setIsOpenSubMenu_(!isOpenSubMenu_);
  };

  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    // localStorage.removeItem("location");
    context.setIsLogin(false);
    // window.location.href = "/signIn"
    history("/");
  };

  // Helper to close sidebar and reset submenu state
  const closeSidebarAndReset = () => {
    setisopenSidebarVal(false);
    setIsOpenSubMenuIndex(null);
    setIsOpenSubMenu_(false);
  };

  return (
    <nav>
      <div className="container">
        <div className="row">
          <div className="col-sm-2 navPart1 hidden md:block">
            <div className="catWrapper">
              <Button
                className={`allCatTab align-items-center ${
                  isopenSidebarVal ? "open" : ""
                }`}
                onClick={() =>
                  isopenSidebarVal
                    ? closeSidebarAndReset()
                    : setisopenSidebarVal(true)
                }
              >
                <span className="icon1 mr-2">
                  <IoIosMenu />
                </span>
                <span className="text">ALL CATEGORIES</span>
                <span className="icon2  ml-2">
                  <FaAngleDown />
                </span>
              </Button>

              <div
                className={`sidebarNav ${
                  isopenSidebarVal === true ? "open" : ""
                }`}
                style={isopenSidebarVal ? {} : { display: "none" }}
              >
                {/* Close button for category sidebar */}
                <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
                  <h6 className="mb-0 font-weight-bold">Categories</h6>
                  <Button
                    className="close-btn p-1 min-w-0"
                    onClick={closeSidebarAndReset}
                    style={{
                      minWidth: "auto",
                      padding: "6px",
                    }}
                  >
                    <IoMdClose size={18} />
                  </Button>
                </div>
                <ul
                  className={`py-2 ${
                    context.windowWidth < 992 ? "flex flex-col" : ""
                  }`}
                >
                  {props.navData?.map((item, index) => {
                    return (
                      <li key={item._id || index} className="relative group">
                        <Link
                          to={`/products/category/${item?._id}`}
                          onClick={() => setisopenSidebarVal(false)}
                        >
                          <Button className="flex items-center w-full text-left hover:bg-gray-100 transition">
                            {item?.name}
                            <FaAngleRight className="ml-auto" />
                          </Button>
                        </Link>

                        {item?.children?.length !== 0 && (
                          <div className="submenu absolute z-50 w-52">
                            {item?.children?.map((subCat, key) => {
                              return (
                                <Link
                                  to={`/products/subCat/${subCat?._id}`}
                                  key={key}
                                  className="block"
                                  onClick={() => setisopenSidebarVal(false)}
                                >
                                  <Button className="w-full text-left hover:bg-gray-100 transition duration-200">
                                    {subCat?.name}
                                  </Button>
                                </Link>
                              );
                            })}
                          </div>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>

          <div
            className={`col-sm-10 navPart2 d-flex align-items-center res-nav-wrapper hidden sm:flex ${
              isOpenNav === true ? "open" : "close"
            }`}
          >
            <div className="res-nav-overlay" onClick={props.closeNav}></div>

            <div className="res-nav">
              {context.windowWidth < 992 && (
                <div className="d-flex align-items-center justify-content-between pl-3 pr-3 pt-2">
                  <Link to="/" className="logo">
                    <img src={Logo} alt="logo" />
                  </Link>
                  <Button
                    className="close-btn p-1 min-w-0"
                    onClick={props.closeNav}
                    style={{
                      minWidth: "auto",
                      padding: "6px",
                      marginTop: "-40px",
                    }}
                  >
                    <IoMdClose color="red" size={20} />
                  </Button>
                </div>
              )}

              <ul
                className={`list list-inline ml-auto flex items-center ${
                  context.windowWidth < 992 ? "flex-col" : ""
                }`}
              >
                {props.navData
                  ?.filter((item, idx) => idx < 7)
                  .map((item, index) => {
                    return (
                      <li className="list-inline-item" key={item._id || index}>
                        <Link
                          to={`/products/category/${item?._id}`}
                          onClick={props.closeNav}
                        >
                          <Button>{item?.name}</Button>
                        </Link>

                        {item?.children?.length !== 0 &&
                          context.windowWidth < 992 && (
                            <span
                              className={`arrow ${
                                isOpenSubMenuIndex === index &&
                                isOpenSubMenu_ === true &&
                                "rotate"
                              }`}
                              onClick={() => IsOpenSubMenu(index)}
                            >
                              <FaAngleDown />
                            </span>
                          )}

                        {item?.children?.length !== 0 && (
                          <div
                            className={`submenu ${
                              isOpenSubMenuIndex === index &&
                              isOpenSubMenu_ === true &&
                              "open"
                            }`}
                          >
                            {item?.children?.map((subCat, key) => {
                              return (
                                <Link
                                  to={`/products/subCat/${subCat?._id}`}
                                  key={key}
                                  onClick={props.closeNav}
                                >
                                  <Button>{subCat?.name}</Button>
                                </Link>
                              );
                            })}
                          </div>
                        )}
                      </li>
                    );
                  })}
              </ul>
              {context.windowWidth < 992 && (
                <>
                  {context?.isLogin === false ? (
                    <div className="pt-3 pl-3 pr-3">
                      <Link to="/signIn">
                        <Button
                          className="btn-blue w-100 btn-big"
                          onClick={props.closeNav}
                        >
                          Sign In
                        </Button>
                      </Link>
                    </div>
                  ) : (
                    <div
                      className="pt-3 pl-3 pr-3"
                      onClick={() => {
                        props.closeNav();
                        logout();
                      }}
                    >
                      <Button className="btn-blue w-100 btn-big">
                        <RiLogoutCircleRFill className="mr-2" /> Logout
                      </Button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
